<ul class="breadcrumbs" [ngClass]="depthClass">
  <li *ngFor="let parent of parents"><a [routerLink]="parent.link">{{parent.name}}</a></li>
  <li>{{page.name}}</li>
</ul>